import { AppLogo } from "@app/components/AppLogo.tsx";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@app/components/shadcn/tooltip.tsx";
import { Env } from "@app/Env.ts";

export const AppTitle = () => (
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger>
        <div className="flex items-center gap-2.5">
          <AppLogo />
          <h1 className="flex items-center gap-2 text-2xl font-extrabold tracking-tight">
            Colmeia
            <span className="rounded-full bg-primary/15 px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wide text-primary">
              Beta
            </span>
          </h1>
        </div>
      </TooltipTrigger>
      <TooltipContent>v{Env.APP_VERSION}</TooltipContent>
    </Tooltip>
  </TooltipProvider>
);
